// extracted by mini-css-extract-plugin
export default {"svg":"styles_svg__XV4-Y","preloader":"styles_preloader__-MiW9"};